/**
 * Returns a fetch function based on the runtime
 */
export async function getFetchFn() {
    return fetch;
}
